var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expandtofill pt-1 d-flex align-center justify-center flex-column"},[_c('h1',[_vm._v("Simulate")])])}]

export { render, staticRenderFns }